import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import Layout from "../../Layout"
import { ProrrogacaoContratualForm } from "../../modais"

class ProrrogacaoContratualEditForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/prorrogacaocontratual")
  }
  render() {
    return (
      <Layout tabActive="Fiscalização">
        <ProrrogacaoContratualForm
          isEditing={true}
          callBackAtaReuniao={this.onSuccess}
        />
      </Layout>
    )
  }
}
export default withRouter(ProrrogacaoContratualEditForm)



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/prorrogacao-contratual/ProrrogacaoContratualEditForm.js